import { message } from 'antd';

import { call, put, takeEvery, all, fork, select, takeLatest } from 'redux-saga/effects'
import { getMrtWorklistAPI } from '../../../services/mrt-service';

import { FETCH_WORKLIST, FETCH_WORKLIST_ERROR, FETCH_WORKLIST_START, FETCH_WORKLIST_SUCCESS, SET_WORKLIST_FILTER, SET_WORKLIST_PAGINATION } from '../../actions/mrt/worklistAction';

function* fetchWorklist({ payload }) {
    try {
        yield put({ type: FETCH_WORKLIST_START })
        const response = yield call(getMrtWorklistAPI, payload);

        if (response.success) {
            const pagination = {
                currentPage: payload.page,
                pageSize: payload.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }
            yield put({ type: FETCH_WORKLIST_SUCCESS, worklist: response.data.mrtWorklist });
            yield put({ type: SET_WORKLIST_FILTER, payload: { ...payload } });
            yield put({ type: SET_WORKLIST_PAGINATION, pagination });
        } else {
            yield put({ type: FETCH_WORKLIST_ERROR, error: response.error })
            message.error('Failed to fetch worklist!');
        }
    } catch (error) {
        yield put({ type: FETCH_WORKLIST_ERROR, error })
        message.error('Failed to fetch worklist!');
    }
}

function* misWorklistWatcher() {
    yield takeEvery(FETCH_WORKLIST, fetchWorklist)
}

export default function* rootSaga() {
    yield all([
        misWorklistWatcher(),
    ]);
}